// Flat SVG icon set — ported verbatim from trip-dashboard-prototype.html.
// stroke=currentColor, 24x24 viewBox.

export const ICONS: Record<string, string> = {
  home: '<path d="M3 11.5 12 4l9 7.5"/><path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9"/>',
  list: '<path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h10"/>',
  map: '<path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z"/><path d="M9 4v14"/><path d="M15 6v14"/>',
  chart: '<path d="M4 20V10"/><path d="M10 20V4"/><path d="M16 20v-7"/><path d="M4 20h16"/>',
  settings:
    '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 19.4a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9a1.7 1.7 0 0 0 1.55 1H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1Z"/>',
  camera:
    '<path d="M4 8a2 2 0 0 1 2-2h1.2l.9-1.5A1 1 0 0 1 9 4h6a1 1 0 0 1 .9.5L16.8 6H18a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Z"/><circle cx="12" cy="13" r="3.3"/>',
  marker: '<path d="M12 21s-7-6.2-7-11a7 7 0 1 1 14 0c0 4.8-7 11-7 11Z"/><circle cx="12" cy="10" r="2.3"/>',
  download: '<path d="M12 3v12"/><path d="m7 11 5 5 5-5"/><path d="M5 21h14"/>',
  search: '<circle cx="11" cy="11" r="6.5"/><path d="m20 20-3.6-3.6"/>',
  inbox:
    '<path d="M3 12h4l2 3h6l2-3h4"/><path d="M5 12 3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1l-2 6"/><path d="M5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6"/>',
  image: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="m21 15-4.5-4.5L9 18"/>',
  fuel: '<path d="M6 21V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v15"/><path d="M4 21h12"/><path d="M14 9h2.3l2.2 2.2V17a1.5 1.5 0 0 1-3 0v-2"/><path d="M6 6h6"/>',
  bed: '<path d="M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6"/><path d="M3 18h18"/><path d="M7 10V7a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3"/>',
  utensils: '<path d="M6 3v7a2 2 0 0 0 4 0V3"/><path d="M8 10v11"/><path d="M17 3c-1.5 0-2.5 1.8-2.5 4.5S15.5 12 17 12v9"/>',
  cart: '<circle cx="9" cy="20" r="1.2"/><circle cx="18" cy="20" r="1.2"/><path d="M3 4h2l2.4 12.2A1.5 1.5 0 0 0 8.9 17.5h8.6a1.5 1.5 0 0 0 1.47-1.2L21 8H6"/>',
  anchor: '<circle cx="12" cy="5" r="2"/><path d="M12 7v13"/><path d="M6 12H2a10 10 0 0 0 10 9 10 10 0 0 0 10-9h-4"/>',
  road: '<path d="M9 3 4 21"/><path d="M15 3l5 18"/><path d="M12 8v1.5"/><path d="M12 13v1.5"/><path d="M12 18v1"/>',
  parking: '<rect x="4" y="3" width="16" height="18" rx="3"/><path d="M9 16V7h3.5a3 3 0 1 1 0 6H9"/>',
  tent: '<path d="M4 20 12 4l8 16"/><path d="M12 4v16"/><path d="M8 20l4-8 4 8"/>',
  ticket:
    '<path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a1.6 1.6 0 0 0 0 3.2V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2.8a1.6 1.6 0 0 0 0-3.2V8Z"/><path d="M10 6v12" stroke-dasharray="2.2 2.2"/>',
  bag: '<path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
  sparkle: '<path d="M12 2 13.6 9 21 12l-7.4 3-1.6 7-1.6-7L2 12l7.4-3z"/>',
  plus: '<path d="M12 5v14"/><path d="M5 12h14"/>',
  wifi_off:
    '<path d="M2 2l20 20"/><path d="M8.5 16.5a5 5 0 0 1 6.6-.3"/><path d="M5 12.5a10.6 10.6 0 0 1 3-2"/><path d="M19 12.5a10.6 10.6 0 0 0-2.3-1.9"/><path d="M2 8.8a15.9 15.9 0 0 1 4.2-2.7"/><path d="M22 8.8a15.9 15.9 0 0 0-8-4.4"/><path d="M12 20h.01"/>',
  lock: '<rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/>',
};

export function icon(name: string, size = 20): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${
    ICONS[name] || ICONS.sparkle
  }</svg>`;
}

export interface IconBadgeOpts {
  size?: string; // css class: icon-badge-sm | icon-badge-md | icon-badge-lg
  round?: boolean;
  cls?: string;
  iconSize?: number;
}

export function iconBadge(name: string, opts: IconBadgeOpts = {}): string {
  const cls = opts.size || 'icon-badge-md';
  const round = opts.round ? ' icon-badge-round' : '';
  const extra = opts.cls ? ' ' + opts.cls : '';
  return `<div class="icon-badge ${cls}${round}${extra}">${icon(name, opts.iconSize || 18)}</div>`;
}

export function iconPlain(name: string, size = 16): string {
  return `<span class="icon-plain">${icon(name, size)}</span>`;
}

export const CATEGORY_ICON_KEY: Record<string, string> = {
  Fuel: 'fuel',
  Accommodation: 'bed',
  Food: 'utensils',
  Groceries: 'cart',
  Ferry: 'anchor',
  'Toll / Vignette': 'road',
  Parking: 'parking',
  Camping: 'tent',
  Attractions: 'ticket',
  Shopping: 'bag',
  Other: 'sparkle',
};

export function catIconKey(cat: string): string {
  return CATEGORY_ICON_KEY[cat] || 'sparkle';
}
